import CxTableMixin from '@/mixins/CxTableMixin';
import ContextMenuMixin from '@/mixins/jlr/JlrContextMenuMixin';

export default {
  mixins: [ CxTableMixin, ContextMenuMixin ],

  data() {
    return {
      columnDefs: [
        { 
          width: 100, 
          minWidth: 100, 
          maxWidth: 100, 
          headerName: "Details", 
          lockPosition: 'left',
          lockVisible: true,
          sortable: false, 
          filter: false,
          resizable: false,
          pinned: 'left',
          cellRenderer: 'linkCellRenderer',
          cellStyle: this.leftCellStyle
        }, { 
          headerName: "Image", 
          field: "ClientLocationId", 
          minWidth: 150, 
          sortable: false, 
          resizable: false,
          lockPosition: 'left',
          lockVisible: true,
          filter: false,
          autoHeight: true, 
          cellRendererSelector: (params) => {
            return { 
              component: isNaN(parseInt(params.value)) 
                ? 'flagCellRenderer' 
                : 'imageCellRenderer' 
            }; 
          },
          cellStyle: this.leftCellStyle
        }, { 
          width: 250,   
          minWidth: 200,
          headerName: "Location", 
          field: "Name", 
          filter: 'agSetColumnFilter',
          suppressMenu: true,
          lockPosition: 'left',
          lockVisible: true,
          pinned: 'left',
          cellRenderer: 'addressCellRenderer',
          cellStyle: this.leftCellStyle
        }, { 
          headerName: "Name", 
          field: "Name", 
          hide: true 
        }, { 
          headerName: "City", 
          field: "City", 
          hide: true 
        }, { 
          headerName: "Postal Code", 
          field: "PostalCode", 
          filter: 'agSetColumnFilter',
          hide: true 
        }, { 
          suppressMenu: true,
          headerName: "JLR Number", 
          field: "CustomLocationId",
          filter: 'agTextColumnFilter',
        }
      ],

      customColumns: { 
        active: [],
        items: []
      },

      defaultColDef: {
        width: 170,
        sortable: true,
        filter: true,
        resizable: true, 
        floatingFilter: true,
        enableRowGroup: false,
        suppressMovable: true,
        cellStyle: {'text-align': 'center', 'text-align': '-webkit-center', 'font-weight': 500, 'font-size': '15px' },
        menuTabs: ['generalMenuTab', 'filterMenuTab']
      },

      leftCellStyle: { 'text-align': 'left', 'text-align': '-webkit-left', 'font-weight': 500, 'font-size': '15px' },

      gridOptions: { 
        domLayout: 'autoHeight',
        suppressAggFuncInHeader: true,
        groupDisplayType: 'custom',
        animateRows: true,
        onGridReady: (event) => {
          event.columnApi.autoSizeAllColumns()

          this.gridApi = event.api;
          this.gridColumnApi = event.columnApi;
        },
        defaultExcelExportParams: this.getExcelSettings(),
        getContextMenuItems: this.getContextMenuItems
      },

      gridApi: null,

      gridColumnApi: null,

      // Inject rows into CustomDataGrid
      rowData: [],

      // pinned to the top
      pinnedTopRowData: []
    }
  }
}
